module.exports = __webpack_public_path__ + "media/4x3/ca-c976442e.svg";